import React from 'react'
import useLatencyTest from './useLatencyTest';

const withLatencyTest = Component => (props) => {
    const isConnectedFast = useLatencyTest()
    
    return <Component 
        isConnectedFast={isConnectedFast}
        {...props} 
    />
}

export default withLatencyTest